export default {
  es: {
    messages: {
      alpha: (input) => 'El campo de ' + input + ' sólo puede contener caracteres alfabéticos',
      alpha_num: (input) => 'El campo de ' + input + ' sólo puede contener caracteres alfanuméricos.',
      required: (input) => 'El campo de ' + input + ' es requerido',
      min: (input) => 'El campo de ' + input + ' debe tener al menos 5 caracteres.',
      alpha_spaces: (input) => 'El campo de ' + input + ' sólo puede contener caracteres alfabéticos, así como espacios.',
      email: (input) => 'El campo de correo no es válido.',
      numeric: (input) => 'El campo de ' + input + ' no es válido.',
      confirmed: (input) => 'El campo ' + input + ' no coindice con la clave.',
      max_value: (input, value) => 'El campo ' + input + ' debe ser ' + value + ' o menos.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/vee.js